module.exports = __webpack_public_path__ + "img/THP.6b3c979f.png";